export default "__VITE_ASSET__CcxCdEId__"